import { Seo } from "@/components/Seo";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import CreditSuperpower from "@/components/CreditSuperpower";
import ComparisonTable from "@/components/ComparisonTable";
import SwitchingIsEasy from "@/components/SwitchingIsEasy";
import NetworkSection from "@/components/NetworkSection";
import AffordablePlansBand from "@/components/AffordablePlansBand";
import PlansSection from "@/components/PlansSection";
import OfferSection from "@/components/OfferSection";
import AppDownload from "@/components/AppDownload";
import FAQSection from "@/components/FAQSection";


import InternshipTestimonials from "@/components/InternshipTestimonials";




import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Seo
        title="Perch Mobile — Turn your phone bill into credit history"
        description="Build credit with every phone payment. Affordable wireless plans starting at $7.99/month with 5G coverage on AT&T's network. No credit check, no contract required."
        path="/"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Perch Mobile",
        "url": "https://perchmobile.com",
        "logo": "https://perchmobile.com/favicon.png",
        "description": "Perch Mobile helps you build credit history with every phone bill payment. Affordable wireless plans on AT&T's 5G network.",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "url": "https://perchmobile.com/contact"
        }
      })}} />
      <Navigation />
      <Hero />
      <HowItWorks />
      <CreditSuperpower />
      <ComparisonTable />
      <SwitchingIsEasy />
      {/* <AffordablePlansBand /> */}
      <PlansSection />
      <NetworkSection />
      {/* <OfferSection /> */}
      {/* <AppDownload /> */}
      {/* <FAQSection /> */}
      <InternshipTestimonials />
      <Footer />
    </div>
  );
};

export default Index;
